// Options are scoped to their nearest [data-list] ancestor so nested lists navigate independently.
const getOptions = (option: HTMLElement): HTMLElement[] =>
  Array.from(option.closest('[data-list]')?.querySelectorAll<HTMLElement>('[data-list-option]') ?? [])

export const focusFirstListOption = (container: HTMLElement | null) => {
  container?.querySelector<HTMLElement>('[data-list] [data-list-option]')?.focus()
}

export const handleListNavigation = (event: React.KeyboardEvent<HTMLElement>) => {
  const options = getOptions(event.currentTarget)
  if (options.length === 0) return

  const currentIndex = options.indexOf(event.currentTarget)
  if (currentIndex === -1) return

  let nextIndex: number
  switch (event.key) {
    case 'ArrowDown':
      nextIndex = (currentIndex + 1) % options.length
      break
    case 'ArrowUp':
      nextIndex = (currentIndex - 1 + options.length) % options.length
      break
    case 'Home':
      nextIndex = 0
      break
    case 'End':
      nextIndex = options.length - 1
      break
    default:
      return
  }

  event.preventDefault()
  options[nextIndex]?.focus()
}
